import { Rule } from "antd/lib/form";

export const advertFormRules = {
    title: (): Rule[] => [{ required: true, max: 127 }]
}